import React from 'react';
import {Route, Navigate} from 'react-router-dom';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <Route
    key="/business/showcase/emulation/"
    path="business/showcase/emulation"
    element={<Navigate to="../business/showcase/skincare/emulation" replace />}
  />,
  <Route
    key="/business/showcase/emulation/home"
    path="business/showcase/emulation/home"
    element={<Navigate to="../business/showcase/skincare/emulation" replace />}
  />,
  <Route key="/business/showcase/skincare/emulation" element={<ShowocaseLayout />}>
    <Route path="business/showcase/skincare/emulation" element={<AsyncPage />} />
  </Route>,
];
